import React from 'react'
import Certificates from '../components/Certificates/Certificates'
import ResourceLinkNav from '../components/shared/ResourceLinkNav/ResourceLinkNav'
import AdminView from '../components/shared/AdminView'

function CertificatesPage() {
  return (
    <ResourceLinkNav>
      <AdminView />
      <Certificates />
    </ResourceLinkNav>
  )
}

export default CertificatesPage